<h2 mat-dialog-title>Rerun {{ data.reportName }}</h2>

<mat-dialog-content class="dialog-content">
  <p class="helper">
    Reruns create a new historical run record and do not replace the original.
  </p>
  <p class="helper">
    All date/time values are interpreted in {{ displayTimezone }}.
  </p>
  @if (data.allowDeliveryOverride !== false) {
    <p class="helper">
      You can override the saved delivery for this run only. The report's saved delivery settings will not change.
    </p>
  }
  @if (data.isSensitive && data.allowDeliveryOverride !== false && form.get('deliveryChannel')?.value === 'email') {
    <p
      class="helper"
      >
      Full Social Security Number fields will be masked in the emailed report. The saved secure SFTP delivery will not change.
    </p>
  }

  <form [formGroup]="form" class="form-grid">
    <mat-form-field appearance="outline">
      <mat-label>Window start</mat-label>
      <input matInput type="datetime-local" formControlName="windowStart" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Window end</mat-label>
      <input matInput type="datetime-local" formControlName="windowEnd" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>As-of date</mat-label>
      <input matInput type="datetime-local" formControlName="asOfAt" />
    </mat-form-field>

    @if (data.allowDeliveryOverride !== false) {
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Delivery channel</mat-label>
        <mat-select formControlName="deliveryChannel">
          <mat-option value="email">Email override{{ data.isSensitive ? ' (full SSNs masked)' : '' }}</mat-option>
          <mat-option value="saved">Use saved {{ data.deliveryChannel === 'ftp' ? 'SFTP' : 'email' }} delivery</mat-option>
        </mat-select>
      </mat-form-field>
    }

    @if (data.allowDeliveryOverride !== false && form.get('deliveryChannel')?.value === 'email') {
      <mat-form-field
        appearance="outline"
        class="full-width"
        >
        <mat-label>To</mat-label>
        <input matInput type="email" formControlName="to" />
        @if (form.get('to')?.hasError('required')) {
          <mat-error>Email address is required.</mat-error>
        }
        @if (form.get('to')?.hasError('email')) {
          <mat-error>Enter a valid email address.</mat-error>
        }
      </mat-form-field>
    }

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Reason</mat-label>
      <textarea matInput rows="3" formControlName="reason"></textarea>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" type="button" (click)="submit()">Rerun report</button>
</mat-dialog-actions>
